import React, { Component } from 'react'
import { push } from 'react-router-redux'
import { connect } from 'react-redux'
import Moment from 'moment'
import validator from 'validator'
import _ from 'lodash'

import RefreshIndicator from 'material-ui/RefreshIndicator'
import NotificationsIcon from 'material-ui/svg-icons/social/notifications'
import { red500, blue300 } from 'material-ui/styles/colors'
import Chip from 'material-ui/Chip'

import resources from '../../reducers/inbox/resources'
import { getContactDetails } from '../../reducers/contact/resources'
import {
  changeConvo,
  setConvoDetails,
  toggleThreadsLoading,
  toggleConvoLoading,
  setContact,
  setInboxState,
} from '../../reducers/inbox/actions'
import { readContactNotifications } from '../../reducers/notification/resources'
import format from '../../utils/format'
import session from '../../utils/session'
import mixpanel from '../../utils/mixpanel'
import config from '../../config';

import { initRoom, leaveRoom } from '../../io'

import InfiniteScroll from '../infinite-scroll'

import './index.css'

class Conversations extends Component {
  componentWillMount() {
    this.setState({
      contacts: [],
      contact: {},
      filterData: {},
      isLoading: true,
      hasMore: true,
      api: null,
      pageStart: 1,
      resetPage: false,
      hasNewMessage: false,
      pageSize: 10
    })
    ;(async () => {
      const { companyId, id: userId } = session.get('userData')
      this.props.initRoom(userId)

      this.companyId = companyId
      this.userId = userId

    })()
  }

  componentWillReceiveProps(nextProps) {
    const { newConvo, newContact, filterData, newMsgContact } = nextProps
    let { contacts } = this.state
    let pageSize = _.isUndefined(this.state.convoHeight) ? 10 : this.state.pageSize;
    const {companyId, role:userRole } = session.get('userData')
    const convoListEl = document.querySelector('.conversation-list');

    /**
     * Assigned checker to prevent changing of 
     * pagesize due to expanded convo height
     */
    if(convoListEl && _.isUndefined(this.state.convoHeight)) {
      // Based on the hieght of .conversation-row
      const rowHeight = 90; 

      // Based on the height of .conversation-row
      const convoHeight = convoListEl.scrollHeight; 

      /**
       * Calculate pageSize that will be used in query
       * based on the height of row data and the container
       * It is round up to have ensure extra pagSize
       */
      pageSize = Math.ceil(convoHeight / rowHeight)

      this.setState({ convoHeight, pageSize })
    }

    this.setState({ isLoading: true })
    
    const isAdmin = userRole === config.userRoles.ghAdmin;
    //if admin switched company via dropdown on appbar
    if (
      isAdmin &&
      nextProps.selectedCompany &&
      nextProps.selectedCompany !== this.companyId
    ) {
      const selectedCompany = nextProps.selectedCompany
        ? nextProps.selectedCompany
        : companyId

      leaveRoom(this.userId)
      this.setState({
        contacts: [],
        contact: {},
        isLoading: true,
        hasMore: true,
        api: null,
        pageStart: 1,
        resetPage: false,
        hasNewMessage: false,
      })

      return (() => {
        const { id: userId } = session.get('userData')
        this.props.initRoom(userId)

        this.companyId = selectedCompany
        this.userId = userId
        this.getContactsWithConvo(filterData, pageSize)
      })()
    }

    if (newMsgContact) {
      const contactIndex = _.findIndex(contacts, { id: newMsgContact.id })

      if (contactIndex === -1) {
        this.setState({ contacts: [newMsgContact].concat(contacts) })
      } else {
        contacts.splice(contactIndex, 1)
        contacts.splice(0, 0, newMsgContact)

        this.setState({ contacts })
      }

      this.handleHasNewMessage()
      this.props.setInboxState({ newMsgContact: null })
    }

    const data = {}
    if (!_.isEmpty(filterData)) {
      ;(() => {
        this.getContactsWithConvo(filterData, pageSize)
      })()
      data.resetPage = true
    }

    if (newConvo) {
      // TODO: add notification
      const { filterData: fltrData } = this.state
      const { type, botmapId, deptId } = fltrData

      if (
        type === 'convoAllRoom' ||
        (type === 'department' && deptId === newContact.department_id) ||
        (type === 'bot' && botmapId === newContact.conversations[0].botmap_id)
      ) {
        const cnt = _.find(contacts, { id: newContact.id })
        if (!cnt) {
          this.setState({ contacts: [newContact].concat(contacts) })
        }
      }
    }

    this.setState({ filterData, ...data })
  }

  componentWillUnmount() {
    leaveRoom(this.userId)
    this.props.toggleThreadsLoading(true)
  }

  getContactsWithConvo = (data, pageSize = 10) => {
    if(!data.length) return;
    
    // map data to match payload
    const trimmed = data.map(data => {
      const { id, type, company_id } = data;
      return { id, type, company_id };
    })

    resources.getConversationByFilters(
      { filters: trimmed },
      `page=1&pageSize=${pageSize}`,
    ).then(res => {
      let contacts = res.data;
      const { contact: currentSelectedContact } = this.state

      if (!currentSelectedContact && (!contacts || !contacts.length)) {
        this.props.setContact(null)
        return this.setState({ isLoading: false, hasMore: false, contacts: [] })
      }

      if (_.isEmpty(currentSelectedContact)) {
      const [contact] = contacts
      this.props.setContact(contact)
        this.setState({
          contacts,
          contact,
          hasMore: true,
        })
      } else {
        this.handleHasNewMessage()
        this.setState({ contacts})
      }

      this.setState({ isLoading: false })
      
    }).catch(() => {
      this.setState({ isLoading: false, hasMore: false, contacts: [] })
    })
  }

  updateConvo = (convo, contact, name) => {
    let state = JSON.parse(JSON.stringify(this.state))
    let index = _.findIndex(state.conversations, { id: convo.id })
    let { contactDetails } = this.state.conversations[index]

    if (contact) {
      let data = _.find(contactDetails, { field: contact.field })
      let contactIndex = _.findIndex(contactDetails, { field: contact.field })

      if ((data || []).value !== contact.value && contactIndex !== -1) {
        contactDetails.splice(contactIndex, 1, contact)
      }

      if (contactIndex === -1) {
        contactDetails.push(contact)
      }
    }

    if (name) {
      convo = {
        ...convo,
        app_name: name.name,
      }
    }

    let newConvo = {
      ...convo,
      contactDetails,
    }

    if (index !== -1) {
      state.conversations.splice(index, 1, newConvo)
    } else {
      state.conversations.push(newConvo)
    }

    if (this.state.selected === newConvo.id) {
      this.props.setConvoDetails(newConvo)
    }

    state.conversations = _.orderBy(state.conversations, 'updated_at', 'desc')
    this.setState(state)
  }

  filterMenu = (event) => {
    event.preventDefault()
    this.setState({
      showFilterMenu: true,
      anchorEl: event.currentTarget,
    })
  }

  handleClose = () => {
    this.setState({
      showFilterMenu: false,
    })
  }

  handleSendMsg = (event) => {
    event.preventDefault()
  }

  getThreads = (item) => () => {
    let state = { ...this.state }
    if (state.selected !== item.id) {
      this.props.changeConvo(item.id)
      this.props.setConvoDetails(null)
      getContactDetails(item.contact_id).then((contact) => {
        if (contact && contact.data) {
          let { contactDetails } = contact.data
          let index = _.findIndex(state.conversations, { id: item.id })

          item = {
            ...item,
            contactDetails,
          }

          state.conversations.splice(index, 1, item)

          this.setState({
            ...state,
            selected: item.id,
          })
          this.props.setConvoDetails(item)
        }
      })
    }
  }

  filterMobile = (mobile) => {
    return mobile
      .replace(/^1|[^\d]+1/g, '')
      .replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3')
  }

  loadMore = (page) => {
    let { contacts, hasMore, filterData } = this.state

    ;(async () => {
      await this.setState({ isLoading: true })

      if (hasMore) {
        if(_.isEmpty(filterData)) {
          filterData = []
        }
        const trimmed = filterData.map(data => {
          const { id, type, company_id } = data;
          return { id, type, company_id};
        })

        let contactRes = await resources.getConversationByFilters(
          {filters: trimmed},
          `page=${page}&pageSize=${this.state.pageSize}`,
        )
        contactRes = contactRes.data

        if (!contactRes.length) {
          return this.setState({ isLoading: false, hasMore: false })
        }

        this.setState({
          contacts: contacts.concat(contactRes),
          isLoading: false,
          hasMore: true,
          resetPage: false,
        })
      }
    })()
  }

  /**
   * Return date/time format for display
   * @param {Date} date
   */
  getActiveTime = (date) => {
    if (!date) return Moment().format('MMM D')

    const currentDay = Moment().format('D M YYYY')
    const lastConvoDay = Moment(date).format('D M YYYY')
    const minutesDiff = Moment().diff(Moment(date), 'minutes')
    const secondsDiff = Moment().diff(Moment(date), 'seconds')
    const dateYearBefore = Moment(date).isBefore(Moment(), 'year')

    // format if message was sent less than a minute
    if (secondsDiff < 60) {
      return `${secondsDiff} sec${secondsDiff > 1 ? 's' : ''} ago`
      // format if message was sent less than an hour
    } else if (minutesDiff < 60) {
      return `${minutesDiff} min${minutesDiff > 1 ? 's' : ''} ago`
      // format if message is sent within the day
    } else if (currentDay === lastConvoDay) {
      return Moment(date).format('h:mm A')
      // format if message was sent from previous years
    } else if (dateYearBefore) {
      return Moment(date).format('MMM D, YYYY h:mm A')
    } else {
      return Moment(date).format('MMM D h:mm A')
    }
  }

  /**
   * Return latest date/time format of the convo threads
   * @param {array} convos
   */
  getLatestThread = (convos) => {
    let threadsArr = convos.reduce((acc, nextVal) => {
      const { threads } = nextVal
      return acc.concat(threads)
    }, [])
    const dates = threadsArr.map(({ updated_at }) => updated_at)
    const maxDate = dates.reduce((acc, nextDate) => {
      return acc > nextDate ? acc : nextDate
    }, '')
    return maxDate
  }

  setHasNewMessageState = (value) => {
    this.setState({ hasNewMessage: value })
  }

  handleHasNewMessage = () => {
    // check if the scroll position is on top. if it is, dont show the chip
    const conversationListEl = document.querySelector('.conversation-list')
    if (conversationListEl.scrollTop === 0) {
      return
    }
    this.setHasNewMessageState(true)
  }

  handleScrollToNewMessage = () => {
    const conversationListEl = document.querySelector('.conversation-list')
    conversationListEl.scrollTop = 0
    this.setHasNewMessageState(false)
  }

  render() {
    const styles = {
      filter: {
        color: '#FFF',
      },
      avatar: {
        float: 'left',
      },
      refresh: {
        marginLeft: '50%',
        position: 'absolute',
        display: this.state.isLoading ? 'inline-block' : 'none',
      },
      sadIcon: {
        height: 90,
        width: 90,
        color: '#F0F0F0',
      },
      notifIcon: {
        height: 16,
        width: 16,
      },
    }

    const { contacts, contact } = this.state

    let items = []
    // eslint-disable-next-line
    contacts.map((cnt, index) => {
      const [conversation] = cnt.conversations
      const { botmap } = conversation
      const { conversations, unread_notif_cnt:unreadCnt } = cnt
      const latestThreadDate = this.getLatestThread(conversations)
      const activeTime = this.getActiveTime(latestThreadDate)

      const iconType = {
        messenger: (
          <div
            className="pull-right"
            style={{
              display: 'inline-block',
              color: '#1DAFFC',
              marginRight: 10,
            }}
          >
            <i className="fab fa-facebook-messenger fa-2x" />
          </div>
        ),
        webchat: (
          <div
            className="pull-right"
            style={{
              display: 'inline-block',
              color: '#0277BD',
            }}
          >
            <img
              src="assets/images/bluechat.png"
              className="conversation-icon"
              alt="blue chat"
            />
          </div>
        ),
        twilio: (
          <div
            className="pull-right"
            style={{ display: 'inline-block', marginRight: 5 }}
          >
            <img
              src="assets/images/greensms.png"
              className="conversation-icon"
              alt="green sms"
            />
          </div>
        ),
        nexmo: (
          <div
            className="pull-right"
            style={{ display: 'inline-block', marginRight: 5 }}
          >
            <img
              src="assets/images/greensms.png"
              className="conversation-icon"
              alt="green sms"
            />
          </div>
        ),
        messagemedia: (
          <div
            className="pull-right"
            style={{ display: 'inline-block', marginRight: 5 }}
          >
            <img
              src="assets/images/greensms.png"
              className="conversation-icon"
              alt="green sms"
            />
          </div>
        ),
      }

      const activeRow = contact.id === cnt.id ? 'active' : ''
      const classRow = 'conversation-row ' + activeRow
      const nameAbbre =
        cnt.name == null
          ? ''
          : (cnt.name.toUpperCase().match(/\b(\w)/g) || []).join(' ')
      let email = ''
      const contactdetailEmail = _.find(cnt.contactdetails, { field: 'email' })
      if (contactdetailEmail && validator.isEmail(contactdetailEmail.value)) {
        email = contactdetailEmail.value
      }

      const contactdetailMobile = _.find(cnt.contactdetails, {
        field: 'mobile',
      })
      let mobile = contactdetailMobile ? contactdetailMobile.value : ''
      mobile = mobile !== '' ? format.forceFormat(mobile) : mobile

      // TODO: fix notification
      items.push(
        <div
          key={index}
          className={classRow}
          onClick={async()=> {
            await readContactNotifications(cnt.id)
            cnt.unread_notif_cnt = 0
            this.props.setContact(cnt)
            this.setState({ contact: cnt })
            mixpanel.track(
              'inbox:switch conversation',
              { data: { contact } }
            );
          }}
        >
          <div className="avatar-wrapper pull-left">
            <div
              style={{
                display: cnt.notif_status ? 'inline-block' : 'none',
                paddingLeft: 6,
              }}
            >
              <NotificationsIcon color={red500} style={styles.notifIcon} />
            </div>
          </div>
          <div
            className="meta"
            style={{
              paddingLeft: cnt.notif_status ? 8 : 29,
            }}
          >
            <p className="top">
              <span 
                onClick={this.props.goToContactDetails(cnt.id)}
                className="name"
              >
                {cnt.name}
              </span>
            </p>
            <p className="bottom">
              {mobile ? <span className="message">{mobile}</span> : null}
              {email ? <span className="message">{email}</span> : null}
            </p>
          </div>
          <div className="pull-right" style={{ marginLeft: 'auto' }}>
            <div className='conversation-icon'>
              {iconType[botmap.type]}
              {unreadCnt>0 ? <div className="unread-conversation-notif"></div>: ""}
            </div>
            <span className="date-time pull-right">{activeTime}</span>
            <div className="clearfix" />
          </div>
        </div>,
      )
    })

    const { pageStart, hasMore, isLoading, resetPage } = this.state

    return (
      <InfiniteScroll
        pageStart={pageStart}
        loadMore={this.loadMore}
        hasMore={hasMore}
        useWindow={false}
        initialLoad={false}
        isLoading={isLoading}
        resetPage={resetPage}
        loader={
          <div className="loader" key={0}>
            <RefreshIndicator
              key={-20}
              size={50}
              left={-25}
              top={100}
              loadingColor="#44B535"
              status={'loading'}
              style={styles.refresh}
            />
          </div>
        }
      >
        {this.state.hasNewMessage ? (
          <Chip
            onClick={this.handleScrollToNewMessage}
            backgroundColor={blue300}
            labelColor="#fff"
            style={{
              position: 'absolute',
              margin: '6px 0',
              left: '40%',
            }}
          >
            New message
          </Chip>
        ) : null}
        {items.length ?
          items :
          <div
            style={{
              position: 'absolute',
              width: '100%',
              marginTop: '20px',
              textAlign: 'center'
            }}
          >
            <strong>Inbox is empty.</strong>
          </div>}
      </InfiniteScroll>
    )
  }
}

const mapStateToProps = (state) => {
  const {
    inbox: { contacts, newConvo, newContact, filterData, newMsgContact },
    company: { selectedCompany },
  } = state

  return {
    contacts,
    newConvo,
    newContact,
    filterData,
    newMsgContact,
    selectedCompany,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    initRoom(id) {
      return initRoom(id)
    },
    changeConvo(id) {
      dispatch(changeConvo(id))
    },
    setConvoDetails(body) {
      dispatch(setConvoDetails(body))
    },
    toggleThreadsLoading(status) {
      dispatch(toggleThreadsLoading(status))
    },
    toggleConvoLoading(status) {
      dispatch(toggleConvoLoading(status))
    },
    setContact(contact) {
      dispatch(setContact(contact))
    },
    setInboxState(data) {
      dispatch(setInboxState(data))
    },
    goToContactDetails(id) {
      return () => {
        dispatch(push(`/contacts/${id}`))
      }
    },
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Conversations)
